import createNavigation from "components/masthead/helpers/create_navigation";
import "./component.scss";

const { initDesktopNavigation, initMobileNavigation } = createNavigation({
  containerSelector: ".js-masthead-made-navigation",
  navigationLinkSelector: ".js-masthead-made-navigation-link",
  navigationContentSelector: ".js-masthead-made-navigation-content",
  activeLinkClassName: "masthead-made-navigation__section--active",
  slideSelector: ".js-masthead-made-slide",
  slideLinkSelector: ".js-masthead-made-slide-link",
  expandedSlideClassName: "masthead-made-navigation__slide--expanded",
  backSelector: '.js-mobile-submenu-trigger[data-direction="back"]',
  mouseleaveCategory: "made",
  mobileBackMode: "level-based"
});

export { initDesktopNavigation, initMobileNavigation };
